export enum ProxyResourceType {
    Site = 'site',
    Function = 'function',
}